export default __webpack_public_path__ + "static/media/expand.de81cdfb.svg";